import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatomoControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-cookie-consent',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    standalone: false
})
export class CookieConsentComponent {
   /**
   * Constructor
   *
   */
  constructor(
    public matomoService: MatomoControlService
  ) {}

  /**
   * Consent
   */
  public consent() {
    this.matomoService.giveConsent();
  }
}
